import {SCHEDULES_API, SCHEDULES_IFRAME_API, SCHEDULES_UPDATE_API} from '../constants/Constants'
import API from "./API";

function getHoraires() {
  return {
    name: 'horaires',
    method: 'get',
    url: `${SCHEDULES_API}`,
  }
}

function getIframe() {
  return {
    name: 'horaires',
    method: 'get',
    url: `${SCHEDULES_IFRAME_API}`,
  }
}

async function postHoraires(data) {
  return API({
    name: 'post_schedules_update',
    method: 'post',
    url: `${SCHEDULES_UPDATE_API}`,
    data,
  })
}

export default {
  getHoraires,
  getIframe,
  postHoraires
}
